import { PolicyLayout } from "../components/PolicyLayout";

export default function SubscriptionPolicy() {
  return (
    <PolicyLayout title="Subscription and Cancellation Policy" updated="November 2026" testId="subscription-policy-page">
      <p>This policy governs recurring memberships purchased through Endure Beyond, currently Gold and Gold Pro. The Muscle School is sold as a one-time enrollment purchase, not a recurring subscription — it is not covered by this policy's cancellation and renewal terms.</p>

      <h2>Before you subscribe</h2>
      <p>Each plan's price, billing interval (monthly or annual), and included access are disclosed before you enroll at checkout.</p>

      <h2>Renewals and authorization</h2>
      <p>Your subscription renews automatically at the interval you selected until you cancel, using the payment method on file with Stripe. We will provide any notice required by law before a material price or plan change takes effect.</p>

      <h2>Cancelling</h2>
      <p>You can cancel future renewals at any time from your account's billing settings. Cancelling stops future charges; it does not, by itself, refund a charge already completed — see our Refund Policy for that separate request.</p>

      <h2>Access after cancellation</h2>
      <p>Unless your specific plan states otherwise, your access continues through the end of the billing period you already paid for, then ends.</p>

      <h2>Payment failures</h2>
      <p>If a renewal payment fails, Stripe may retry the charge; your access may be paused if payment cannot be completed, consistent with the terms you agreed to at enrollment.</p>

      <h2>Contact</h2>
      <p>Endure Beyond Media LLC, 563 West Bay Area Boulevard, Unit 119, Webster, TX 77598, United States — <a href="mailto:edm@endurebeyondpod.com" className="underline hover:text-brandAccent">edm@endurebeyondpod.com</a> — +1 (804) 801-2297.</p>
    </PolicyLayout>
  );
}
